import { Github, Mail, Globe } from 'lucide-react';

export function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">
          About nCoder AI
        </h1>
        <p className="mt-4 text-lg text-gray-600">
          Building the future of development tools
        </p>
      </div>

      <div className="prose prose-lg mx-auto">
        <div className="bg-white rounded-lg shadow-sm border p-4 sm:p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
          <p className="text-gray-600 mb-6">
            At nCoder AI, we're dedicated to creating powerful, intuitive development tools
            that empower developers to build amazing applications faster and more efficiently.
            Our platform combines cutting-edge technology with user-friendly design to deliver
            an exceptional development experience.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3">What We Offer</h3>
          <ul className="space-y-2 text-gray-600 mb-6">
            <li>• Modern development environment with hot reloading</li>
            <li>• TypeScript support out of the box</li>
            <li>• Tailwind CSS for rapid UI development</li>
            <li>• Optimized build process with Rspack</li>
            <li>• Clean, maintainable code structure</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mb-3">Get in Touch</h3>
          <div className="flex flex-wrap gap-4">
            <a
              href="https://github.com/nCoderAI"
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <Github className="w-5 h-5" />
              GitHub
            </a>
            <a
              href="mailto:contact@ncoder.ai"
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <Mail className="w-5 h-5" />
              Email
            </a>
            <a
              href="https://ncoder.ai"
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <Globe className="w-5 h-5" />
              Website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// Default export for the page
export default AboutPage;